import React, { useState, createContext, useContext } from "react";

import { getHasValidTruWeatherCredentials } from "../util";

export const EnvContext = createContext();

export function useEnv() {
    return useContext(EnvContext);
}

export function EnvProvider({ children }) {
    const [dataLoggingOn, setDataLoggingOn] = useState("false");
    const [odotDeployment, setOdotDeployment] = useState("");
    const [laancOn, setLaancOn] = useState("false");
    const [laancTileServerUrl, setLaancTileServerUrl] = useState("");
    const [baseMapTileOptions, setBaseMapTileOptions] = useState([]);
    const [weatherOptions, setWeatherOptions] = useState([]);
    const [hasValidTruWeatherCredentials, setHasValidTruWeatherCredentials] = useState(null);
    const [feedbackFormEnabled, setfeedbackFormEnabled] = useState(false);

    const fetchEnvVariables = () => {
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" }
        };
        fetch("api/env/get", requestOptions)
            .then((response) => (response.ok ? response.json() : Promise.reject(response)))
            .then((data) => updateEnvVariables(data))
            .catch((err) => console.error(err));
    };
    const updateEnvVariables = async (data) => {
        const dataLoggingOn = data.DATA_LOGGING_ON;
        setDataLoggingOn(dataLoggingOn);

        const odotDeployment = data.ODOT_DEPLOYMENT;
        setOdotDeployment(odotDeployment);

        const laancOn = data.LAANC_ON;
        setLaancOn(laancOn);

        const laancTileServerUrl = data.LAANC_TILESERVER_URL;
        setLaancTileServerUrl(laancTileServerUrl);

        const feedbackFormEnabledVar = data.FEEDBACK_FORM_ENABLED;
        setfeedbackFormEnabled(feedbackFormEnabledVar);

        try {
            setBaseMapTileOptions(JSON.parse(data.BASE_MAP_TILE_OPTIONS));
        } catch (err) {
            console.error(err);
        }
        try {
            const newWeatherOptions = JSON.parse(data.WEATHER_OPTIONS);
            setWeatherOptions(newWeatherOptions);

            const truWeatherLayer = newWeatherOptions.find(({ type }) => {
                return type === "TRUWEATHER_WMTS";
            });
            let validTruWeatherCredentials = false;
            if (truWeatherLayer) {
                try {
                    validTruWeatherCredentials = await getHasValidTruWeatherCredentials();
                } catch (err) {
                    console.error("An error occured while checking the truweather credentials", err);
                }
            }
            setHasValidTruWeatherCredentials(validTruWeatherCredentials);
        } catch (err) {
            console.error(err);
        }

        // add more here...
    };

    const value = {
        dataLoggingOn,
        odotDeployment,
        laancOn,
        fetchEnvVariables,
        laancTileServerUrl,
        baseMapTileOptions,
        setBaseMapTileOptions,
        weatherOptions,
        hasValidTruWeatherCredentials,
        feedbackFormEnabled
    };

    return <EnvContext.Provider value={value}>{children}</EnvContext.Provider>;
}
